const messages: string[] = [
  "Commencing System Check",
  "Memory Unit: Green",
  "Initializing Tactics Log",
  "Loading Geographic Data",
  "Vitals: Green",
  "Remaining MP: 100%",
  "Black Box Temperature: Normal",
  "Black Box Internal Pressure: Normal",
  "Activating IFF",
  "Activating FCS",
  "Initializing Pod Connection",
  "Launching DBU Setup",
  "Activating Inertia Control System",
  "Activating Environmental Sensors",
  "Equipment Authentication: Complete",
  "Equipment Status: Green",
  "All Systems Green",
  "Combat Preparations Complete",
];

export default messages;
